<p-table 
  class="p-datatable-gridlines text-sm p-datatable-responsive" 
  [value]="skeletonRows">

  <!-- Optional Caption -->
  @if (showCaption()) {
    <ng-template pTemplate="caption">
      <div class="grid md:grid-cols-12 md:text-base text-sm">
        <div class="col-span-3 my-auto md:mx-0 mb-3">
          <p-skeleton [width]="captionWidth()" height="1.6rem"></p-skeleton>
        </div>
        <div class="md:col-span-9 sm:text-right text-center">
          <div class="md:flex grid grid-cols-12 gap-2 justify-end gap-4">
            @if (captionActionCount() === 1) {
              <div class="col-span-12">
                <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
              </div>
            } @else {
              <div class="col-span-6">
                <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
              </div>
              <div class="col-span-6">
                <p-skeleton width="8rem" height="2.5rem"></p-skeleton>
              </div>
            }
          </div>
        </div>
      </div>
    </ng-template>
  }

  <!-- Table Header -->
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns(); track $index) {
        <th [style.width]="col.width">
          <p-skeleton [width]="col.headerWidth || '6rem'" height="1rem"></p-skeleton>
        </th>
      }
      @if (showActions()) {
        <th width="50px"></th>
      }
    </tr>
  </ng-template>

  <!-- Table Body -->
  <ng-template pTemplate="body">
    <tr>
      @for (col of columns(); track $index) {
        <td>
          <span class="p-column-title">
            <p-skeleton [width]="col.headerWidth || '4rem'" height="1rem"></p-skeleton>
          </span>
          <div class="w-[25%] lg:w-full">
            <p-skeleton
              [width]="col.cellWidth || '6rem'"
              [height]="col.cellHeight || '1rem'">
            </p-skeleton>
          </div>
        </td>
      }
      @if (showActions()) {
        <td class="action-td">
          <div class="flex items-center justify-center">
            @if (actionType() === 'circle') {
              <p-skeleton shape="circle" size="2rem"></p-skeleton>
            } @else {
              <p-skeleton width="4rem" height="2rem"></p-skeleton>
            }
          </div>
        </td>
      }
    </tr>
  </ng-template>

</p-table>
